import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class FilterDropdown extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      open: "-open",
      active: "-active",
    }
  }

  ui() {
    return {
      toggle: ".dropdown-toggle",
      options: ".dropdown-option",
      label: ".dropdown-filter-label",
      optionInputs: ".dropdown-option-input",
    }
  }

  attachEvents() {
    const { toggle, options, label, optionInputs } = this.$ui
    const { open, active } = this.dynamicClasses

    toggle.addEventListener("click", () => this.$el.classList.toggle(open))

    iterable(options).forEach((option) => {
      option.addEventListener("click", () => {
        this.$el.classList.remove(open)
        const input = option.querySelector("input")
        if (input) {
          input.checked = true
          input.dispatchEvent(new Event("change", { bubbles: true }))
        }
      })
    })

    iterable(optionInputs).forEach((input) => {
      input.addEventListener("change", (e) => {
        if (!e.target.checked) return

        if (label) label.textContent = e.target.getAttribute("data-label")

        iterable(options).forEach((opt) => opt.classList.remove(active))
        e.target.closest(".dropdown-option").classList.add(active)

        const selectedCategory = e.target.getAttribute("data-category")
        const isAllCategorySelected = selectedCategory === "all"

        document
          .querySelectorAll(".section-contact-category-container")
          .forEach((container) => {
            const containerCategory = container.getAttribute("data-category")
            const isEmptyCategory =
              container.querySelector(".section-contact-empty-category") !==
              null

            const shouldShow =
              (isAllCategorySelected && !isEmptyCategory) ||
              (!isAllCategorySelected && containerCategory === selectedCategory)

            container.style.display = shouldShow ? "" : "none"
          })
      })
    })

    document.body.addEventListener("click", (e) => {
      if (!e.target.closest(`#${this.$el.id}`)) this.$el.classList.remove(open)
    })
  }

  created() {
    this.attachEvents()
  }
}
